import { Box, Slider } from "@mui/material";
import { useEffect, useState } from "react";
import {
    rangeSelectLabelFormatter,
    rangeSelectValueProvider,
} from "../../constants/ProjectConstants";

// updated
export default function SmsCampaignRangeSelect(props: {
    from?: number;
    to?: number;
    valueProvider: rangeSelectValueProvider;
    onValueChange: (min: number, max: number) => void;
}) {
    const [from, setFrom] = useState<number | null>(
        props.from ?? props.valueProvider.min
    );
    const [to, setTo] = useState<number | null>(
        props.to ?? props.valueProvider.max
    );

    useEffect(() => {
        setFrom(props.from ?? props.valueProvider.min);
        setTo(props.to ?? props.valueProvider.max);
    }, [props.from, props.to]);

    const onDragEnded = () => {
        let valueFrom = from;
        let valueTo = to;

        if (from === props.valueProvider.min) {
            valueFrom = null;
        }

        if (to === props.valueProvider.max) {
            valueTo = null;
        }

        props.onValueChange(valueFrom, valueTo);
    };

    return (
        <Box sx={{ width: "100%", px: 2, boxSizing: "border-box" }}>
            <Slider
                value={[from, to]}
                disableSwap
                min={props.valueProvider.min}
                max={props.valueProvider.max}
                step={props.valueProvider.step}
                marks={props.valueProvider.marks?.map((i) => {
                    return {
                        value: i,
                    };
                })}
                onChangeCommitted={onDragEnded}
                onChange={(event: Event, newValue: number[]) => {
                    let from: number | null = newValue[0];
                    let to: number | null = newValue[1];

                    // enable min distance between handlers
                    if (newValue[1] - newValue[0] < 1) {
                        return;
                    }

                    setFrom(from);
                    setTo(to);
                }}
                valueLabelDisplay="auto"
                valueLabelFormat={rangeSelectLabelFormatter(
                    props.valueProvider
                )}
            />
        </Box>
    );
}
